module.exports = __webpack_public_path__ + "static/media/walletConnectIcon.5e81cac2.svg";